import { useState } from 'react';
import SearchBar from 'src/componentes/filtro/search-drawer/SearchBar';
import InformacoesBasicas from './secoes/InformacoesBasicas';
import InformacoesControle from './secoes/InformacoesControle';
import InformacoesItemImpactado from './secoes/InformacoesItemImpactado';
import InformacoesRisco from './secoes/InformacoesRisco';
import CustomFieldsSection from 'src/componentes/filtro/search-drawer/CustomFieldsSection';
import { useIntl } from 'react-intl';

function SearchDrawer({ model, config, hideControlesFilter, parameters }) {
  const [searchQuery, setSearchQuery] = useState('');
  const intl = useIntl();

  return (
    <div>
      <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

      <InformacoesBasicas
        model={model}
        config={config}
        searchQuery={searchQuery}
      />
      <InformacoesControle
        model={model}
        config={config}
        hideControlesFilter={hideControlesFilter}
        parameters={parameters}
        searchQuery={searchQuery}
      />
      <InformacoesRisco
        model={model}
        config={config}
        hideControlesFilter={hideControlesFilter}
        parameters={parameters}
        searchQuery={searchQuery}
      />
      <InformacoesItemImpactado
        model={model}
        config={config}
        hideControlesFilter={hideControlesFilter}
        parameters={parameters}
        searchQuery={searchQuery}
      />
      <CustomFieldsSection
        model={model}
        intl={intl}
        searchQuery={searchQuery}
      />
    </div>
  );
}

export default SearchDrawer;
